<template>
  <v-card class="text-center infoBannerContent" flat>
     <div >
        <!-- <v-icon x-large  class="content">mdi-gift</v-icon> -->
        <v-img :src="require('@/assets/image/projectcount.png')" style="width:3.91em;margin: auto; margin-top:-25.4974px;" ></v-img>
        <!-- <v-img :src="require('@/assets/image/projectcount.png')" style="width: 3.91em; height:3.91em;margin-left:272.1726px; margin-top:-25.4974px;" ></v-img> -->
        
        <v-card-text>
          <h5 class="content">Projects</h5>
          <h5 class="content count">{{ numberOfProjects }}</h5>
      </v-card-text>
    </div>
  </v-card>
</template>
<script>
export default {
  name: "projectCount",
  props: ["numberOfProjects"],
};
</script>
<style scoped>
.infoBannerContent{
  background-color: transparent;
}
.content {
  margin: auto;
  font-size: 25px;
  line-height : 22.65px;
  font-weight: 300;
  color : #FFFFFF;
}
.count{
  padding-top: 12.6769px;
  font-size : 29px;
  line-height : 22.65px;
  font-weight: 200;
}
</style>>